import Vue from 'vue'
import { Message, Loading } from 'element-ui'
import axios from 'axios'
import * as constants from './constants'
import qs from 'qs';
import FileSaver from 'file-saver';

require('es6-promise').polyfill()

axios.defaults.timeout = 5000;
axios.defaults.headers = {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};
axios.defaults.baseURL = process.env.HOST_NAME;
//请求拦截器 在这里面确定header
axios.interceptors.request.use((config) => {
  //store.dispatch(types.UPDATE_LOADING_STATUS, true)
  Loading.service({
    // lock: true,
    text: 'Loading...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  config.headers['authorization'] = sessionStorage.getItem(constants.TOKEN);

  if(config.url.endsWith("/record/export"))
    config.responseType = "blob";

  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }
  return config
}, (error) => {
  //store.dispatch(types.UPDATE_LOADING_STATUS, false)
  Message.error('世界上最遥远的距离就是没有网络~');
  console.log(error)
  return Promise.reject(error)
})
axios.interceptors.response.use((response) => {
  //store.dispatch(types.UPDATE_LOADING_STATUS, false)
  Loading.service({}).close();

  //forbidden
  if(response.status == 403){
    Message.error("登陆令牌失效");
    sessionStorage.removeItem(constants.USERINFO);
    sessionStorage.removeItem(constants.TOKEN);
    Vue.$router.replace("/login");
    return;
  }

  //unauthorization
  if(response.status === 401){
    Message.error("未授权");
    Vue.$router.replace("/");
    return ;
  }


  if(response.status === 400){
    Message.error("操作失败");
    return;
  }

  //判定是下载逻辑
  if(response.config.url.endsWith("/record/export")){
    let blob = new Blob([response.data],{type: 'application/pdf'}); //创建一个blob对象
    // let url = URL.createObjectURL(blob);
    let downloadName = response.headers["content-disposition"].split(";")[1].split("filename=")[1];
    FileSaver.saveAs(blob, decodeURI(downloadName));
/*    let a = document.createElement('a'); //创建一个<a></a>标签
    // let url = URL.createObjectURL(blob)
    a.href = url; // response is a blob
    a.download = response.headers["content-disposition"].split(";")[1].split("filename=")[1];  //文件名称
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);*/
    // window.open(url,"_blank");
    return response;
  }



  if(response.data.code !== "1"){
     Message.error(response.data.message);
     return ;
  }

  return response
}, (error) => {
  Message.error('请求君迷路了~~404')
  console.log(error)
  return Promise.reject(error)
});


Vue.prototype.$http = axios;



// WEBPACK FOOTER //
// ./src/utils/ajax.js